import { AbstractPmsApiService } from "./abstract.service";
import { ChannelManagerGlobalSettings } from "../models";

/**
 * @abstract
 * @extends {AbstractPmsApiService<ChannelManagerGlobalSettings>}
 */
export class ChannelManagerGlobalSettingsService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/channel-manager-global-settings';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ChannelManagerGlobalSettings}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ChannelManagerGlobalSettings(attributes);
    }

    /**
     * @returns {Promise.<ChannelManagerGlobalSettings>}
     */
    get() {

        return this.http
            .get(this.url(), {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ChannelManagerGlobalSettings[]} models
     * @returns {Promise.<ChannelManagerGlobalSettings>}
     */
    save(models) {

        return this.http
            .post(this.url(), {models: models}, {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/channel-manager-global-settings.service.js